/**
 * Who sees the Protect tab (owner, 2026-10-22): only the desk accounts rayan, ghamdan,
 * evatest and samer. The servers enforce the same rule (212 app/edge/protect_acl.py, 146
 * protect_proxy.py); this only hides the tab. The token payload is decoded, not verified --
 * no secret in the browser, and a forged payload still gets 403 from the API.
 */
import { getAuthToken } from "./authUtils";

const env = (typeof process !== "undefined" && process.env) || ({} as Record<string, string | undefined>);

const split = (raw: string | undefined, fallback: string): Set<string> =>
    new Set(
        (raw && raw.trim() ? raw : fallback)
            .split(/[,;]/)
            .map((s) => s.trim().toLowerCase())
            .filter(Boolean),
    );

const ALLOWED_IDS = split(env.REACT_APP_PROTECT_ALLOWED_IDS, "19,25,388,556");
const ALLOWED_NAMES = split(env.REACT_APP_PROTECT_ALLOWED_NAMES, "ghamdan,rayan,samer,evatest,g.althawr,tariq.jbour");

interface TokenUser {
    id?: number | string | null;
    username?: string | null;
    email?: string | null;
}

function decodeTokenUser(token: string | null): TokenUser | null {
    if (!token) return null;
    try {
        const part = token.split(".")[1];
        if (!part) return null;
        const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
        const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));
        const user = payload?.data?.user;
        return user && typeof user === "object" ? (user as TokenUser) : null;
    } catch {
        return null;
    }
}

export function userAllowedForProtect(user: TokenUser | null | undefined): boolean {
    if (!user) return false;
    if (user.id !== undefined && user.id !== null && ALLOWED_IDS.has(String(user.id).trim().toLowerCase())) {
        return true;
    }
    const username = String(user.username || "").trim().toLowerCase();
    if (username && ALLOWED_NAMES.has(username)) return true;
    const email = String(user.email || "").trim().toLowerCase();
    const at = email.indexOf("@");
    return at > 0 && ALLOWED_NAMES.has(email.slice(0, at));
}

/** True when the signed-in session token names an allowed user. */
export function canUseProtect(): boolean {
    return userAllowedForProtect(decodeTokenUser(getAuthToken()));
}
